<template>
    <div class="pb-6  mx-8">
        <div class="w-full">
        <p>
          A selection of health based resources and educational aids to use and work through as part of a health based approach or alongside other as part of a wider health and wellbeing curriculum.
        </p>
      </div>

        <h3 class="font-semibold mb-5 pt-2">Free to use from the PE Passport</h3>

        <div  class="grid grid-cols-2 md:grid-cols-4 gap-4 mr-10 pb-32 ">
            <div class="w-full h-56 block cursor-pointer hover:opacity-75"  v-for="data in contentList" :key="data.title" @click="showContent(data)">
                <div class="block w-full h-full" 
                :title="data.title"
                :style="{ backgroundImage: 'url(' + contentImage(data) + ')' }"
                style="
          background-position: top left;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        " >

                </div>
               
            </div>
        </div>



    </div>    
</template>

<script>

    import json from '@/assets/health_content.json'
    export default{
        name: "HealthResources",
        computed: {
        contentList() {
            return this.resources.filter((object) => {
                return object.active === true
            })
        }
},
        data(){
            return {
                resources: json
            }
        },
        methods: {
    contentImage(item) {
      return require('@/assets/images/health/' + item.image + '.png')
    },
    showContent(item) {
        this.$router.push({
        name: "HealthContent",
        params: { healthObject: item },
      });
    }
}

    }
</script>
<style scoped>


</style>
